import { createSelector } from 'reselect';

import { getCoworkingWorkplacesSelector } from './getCoworkingWorkplacesSelector';

export const getCoworkingFixedWorkplaceSelector = createSelector(
  [getCoworkingWorkplacesSelector],
  workplaces => workplaces?.fixed ?? null,
);
